const projects = [
  {
    id: "project-1",
    ekranId: "ekran1",
    textureIndex: 0,
    title: "Velric",
    shortDescription: "Hire based on execution, not resumes.",
    description: "Most hiring pipelines never actually see what candidates can do. Velric was built to change that. An AI-powered proof-of-work hiring platform that onboarded 5,500+ candidates and completed 1,200+ missions, delivering a full-stack EdTech MVP 25% ahead of schedule with 99.8% peak uptime by integrating OpenAI API with a PostgreSQL/Supabase backend. A Figma-to-Tailwind CSS token system enabled 40+ concurrent company onboardings and cut design-to-release cycles by 40%. A comprehensive Jest and React Testing Library suite achieved 92% unit-test coverage, reducing production regressions by 30% and eliminating a full sprint cycle from QA. Velric doesn't just score resumes. It proves who can actually build.",
    techStack: ["Next.js", "TypeScript", "Supabase", "PostgreSQL", "OpenAI API", "Tailwind CSS", "Jest", "React Testing Library"],
    liveUrl: "https://velric.ai/",
    images: ["/img/img/01.png", "/img/img/01.png", "/img/img/01.png"],
    year: 2025,
    category: "AI & EdTech"
  },
  {
    id: "project-2",
    ekranId: "ekran2",
    textureIndex: 1,
    title: "Vaultly",
    shortDescription: "The only app you'll ever need to stay organized",
    description: "Most people lose 2.5 hours every day hunting for scattered notes, prompts, and links across 6 different apps. Vaultly eliminates that chaos entirely. Built with zero trust data isolation and Row Level Security enforcing a 90% reduction in unauthorized cross tenant query attempts, it becomes the single source of truth for everything that matters; job applications, tools, prompts, passwords, and research; all surfaced instantly through intelligent search. Engineered on Next.js 14 App Router with a JSONB single table PostgreSQL schema that scales user capacity 10x without a single migration, Vaultly doesn't just store your information. It gives it back to you exactly when you need it.",
    techStack: ["Next.js 14", "TypeScript", "Supabase", "PostgreSQL", "Tailwind CSS", "shadcn/ui", "Vercel"],
    liveUrl: "https://vaultly-safe.vercel.app/",
    images: ["/img/img/08.png", "/img/img/08.png", "/img/img/08.png"],
    year: 2026,
    category: "Security & Privacy"
  },
  {
    id: "project-3",
    ekranId: "ekran3",
    textureIndex: 2,
    title: "HumanGrade",
    shortDescription: "Search the internet. Not the AI's version of it.",
    description: "Since ChatGPT launched in late 2022, AI generated content has flooded search results to the point where Google's own studies show users increasingly cannot distinguish synthetic answers from real ones. HumanFirst was built as a direct antidote. An open source Manifest V3 browser extension that simultaneously connects to 7 verified search engines and cuts non human results by 75%, completely stripping AI overviews, synthetic summaries, and generated blog spam from the results page. Engineered with a service worker architecture that achieves 100% backend request reduction through complete client side filtering, it runs natively across Chrome, Edge, Brave, and Firefox; no servers, no tracking, no middleman.",
    techStack: ["JavaScript", "Chrome Extension Manifest V3", "Content Scripts", "Service Workers"],
    liveUrl: "https://human-grade.vercel.app/",
    images: ["/img/img/007.png", "/img/img/007.png", "/img/img/007.png"],
    year: 2026,
    category: "Design & UX"
  },
  {
    id: "project-4",
    ekranId: "ekran4",
    textureIndex: 3,
    title: "Mirrin Agency",
    shortDescription: "Stop paying for pretty. Start investing in profitable.",
    description: "Most agencies sell founders a digital brochure that looks polished and converts no one. Mirrin was founded to end that industry wide lie. A full service conversion focused design agency delivering complete web platforms in just a day or two sprints; 60% faster than the industry standard; for early stage startups and e-commerce brands who cannot afford to wait. Built for and by a founder who has personally generated over $40K in client revenue through interface redesigns and CRO, the Mirrin site itself is the proof of concept: psychology led design, clean code architecture, and SEO built in from day one. Trusted by 8 plus clients across fintech, e-commerce, and SaaS, with a component library and design system that cuts feature deployment time by 40% and eliminates brand fragmentation for good.",
    techStack: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion", "Figma"],
    liveUrl: "https://mirrin.vercel.app/",
    images: ["/img/img/11.png", "/img/img/11.png", "/img/img/11.png"],
    year: 2025,
    category: "Agency & Branding"
  },
  {
    id: "project-5",
    ekranId: "ekran5",
    textureIndex: 4,
    title: "Mirrin Design Studio",
    shortDescription: "The studio where brands stop looking average",
    description: "94% of first impressions are design driven and most of them are wasted on generic templates disguised as custom work. Mirrin Design Studio was built as the visual proof that it does not have to be that way. A hero section concept for a premium creative studio targeting influencers, creators, and brands who are actively bleeding revenue from forgettable web presence. The experience opens on a cinematic 3D meadow rendered with depth and natural light, pairs it with a typographic headline that lands emotionally before the eye even finishes reading, and transitions into a works flow that sells without selling. Engineered with Next.js and Framer Motion for sub 1.5 second loads with buttery scroll performance across every device.",
    techStack: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion", "Three.js"],
    liveUrl: "https://mirrin-hero-section-01.vercel.app/",
    images: ["/img/img/09.png", "/img/img/09.png", "/img/img/09.png"],
    year: 2025,
    category: "Agency & Branding"
  },
  {
    id: "project-6",
    ekranId: "ekran6",
    textureIndex: 5,
    title: "Mirrin Financial Inc",
    shortDescription: "Capital that moves as fast as the founders who need it",
    description: "Traditional VC firms take 6 to 18 months to close a round; an eternity for founders operating at startup velocity. Mirrin Financial was designed to obliterate that friction. The platform surfaces non dilutive capital and strategic equity pathways through a conversion optimized landing experience built for founders who refuse to wait. Engineered with Next.js and Framer Motion to load under 1.2 seconds and hold attention past the 8 second drop off threshold, every scroll interaction, CTA placement, and visual hierarchy decision was driven by one goal: turning relentless founders into funded ones.",
    techStack: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion"],
    liveUrl: "https://mirrin-financial-inc-s3dk.vercel.app/",
    images: ["/img/img/06.png", "/img/img/06.png", "/img/img/06.png"],
    year: 2025,
    category: "Finance & Landing Pages"
  },
  {
    id: "project-7",
    ekranId: "ekran7",
    textureIndex: 6,
    title: "Web3 Hero Section",
    shortDescription: "Web3 infrastructure that finally feels like the future",
    description: "Over 80% of Web3 projects lose users in the first 10 seconds because their interfaces look like crypto forums from 2017. FOS was designed to shatter that expectation. Built as a high performance hero section for a next generation Web3 infrastructure platform, the experience opens with a cinematic rotating planet, communicates speed and scale in a single scroll, and converts curiosity into waitlist signups without a single paragraph of jargon. Engineered with React, Framer Motion, and a precision dark design system, it benchmarks in the top 5% of Web3 landing pages for visual retention and perceived trust.",
    techStack: ["React", "Next.js", "Tailwind CSS", "Framer Motion", "TypeScript", "WebGL"],
    liveUrl: "https://web3-hero-section.vercel.app/",
    images: ["/img/img/05.png", "/img/img/05.png", "/img/img/05.png"],
    year: 2024,
    category: "Web3 & Landing Pages"
  },
  {
    id: "project-8",
    ekranId: "ekran8",
    textureIndex: 7,
    title: "3D BMW Book",
    shortDescription: "A car brochure that actually moves you",
    description: "Static product pages convert at under 2% because they ask people to imagine what they cannot feel. The 3D BMW Book eliminates that imagination gap entirely. Built as a fully interactive 3D magazine experience for the BMW M4 Competition, it lets users physically flip through pages in real time, each one rendered with depth, motion blur, and cinematic lighting that makes the M4 feel like it is right in front of you. Powered by Three.js, React Three Fiber, and GSAP with smooth 60fps page turning physics, this is what automotive storytelling looks like when the web stops pretending it is print.",
    techStack: ["React", "Three.js", "React Three Fiber", "GSAP", "WebGL"],
    liveUrl: "https://3-d-bmw-book.vercel.app/",
    images: ["/img/img/04.png", "/img/img/04.png", "/img/img/04.png"],
    year: 2024,
    category: "3D Showcase"
  },
  {
    id: "project-9",
    ekranId: "ekran9",
    textureIndex: 8,
    title: "3D Earth",
    shortDescription: "One planet. No backup. Feel it.",
    description: "Most environmental campaigns fail to create urgency because they communicate with statistics instead of sensation. 3D Earth was built to close that gap. It drops the user directly into a live rotating photorealistic Earth rendered with high resolution NASA texture maps, atmospheric glow, and a star field that makes the scale of what is at stake viscerally undeniable. Engineered with Three.js, React Three Fiber, and GSAP with 60fps performance across all modern browsers, it is the kind of interactive experience that makes someone stop scrolling, sit with it, and actually feel something. That is the goal.",
    techStack: ["React", "Three.js", "React Three Fiber", "WebGL", "GSAP"],
    liveUrl: "https://3-d-earth-page.vercel.app/",
    images: ["/img/img/02.png", "/img/img/02.png", "/img/img/02.png"],
    year: 2024,
    category: "3D Web Experience"
  },
  {
    id: "project-10",
    ekranId: "ekran10",
    textureIndex: 9,
    title: "Mirrin Health",
    shortDescription: "Anti-aging is dead. Pro-living starts here.",
    description: "The global longevity supplement market hit $44 billion in 2023 and is still drowning in brands that lead with buzzwords and bury the science. Mirrin Health was designed to flip that entirely. The landing experience leads with a molecular level visual of the product working inside the body, communicates cellular repair science through a clean bold typographic hierarchy, and converts skeptics into believers before the first scroll ends. Built with React, Next.js, and Framer Motion with a soft bioluminescent aesthetic that signals credibility without clinical coldness, this is what the next generation of wellness looks like when design actually does the selling.",
    techStack: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion"],
    liveUrl: "https://mirrin-health.vercel.app/",
    images: ["/img/img/03.png", "/img/img/03.png", "/img/img/03.png"],
    year: 2024,
    category: "Health & Wellness"
  }
];

export const getProjectById = (id) => {
  return projects.find(project => project.id === id);
};

export const getProjectByEkranId = (ekranId) => {
  return projects.find(project => project.ekranId === ekranId);
};

export const getAllProjects = () => projects;

export const getProjectsByCategory = (category) => {
  return projects.filter(project => project.category === category);
};

export default projects;